import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {transition, trigger, useAnimation} from '@angular/animations';
import {fadeInDown} from 'ng-animate';
import {ApirequestService} from '../../../../services/apirequest/apirequest.service';
import {ApiurlsService} from '../../../../services/api-urls/apiurls.service';
import {UtilityService} from '../../../../services/utilities/utilities.services';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastsManager} from 'ng2-toastr';
import {OrderPipe} from 'ngx-order-pipe';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BlurInputErrorMatcher} from '../../../../modules/material/material.errror';

@Component({
  selector: 'hybse-admin-vconfig-add',
  templateUrl: './vconfig-add.component.html',
  styleUrls: ['./vconfig-add.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class VconfigAddComponent implements OnInit {
  public vconfigForm: FormGroup;
  public secondaryAssets: any = [];
  public showLoader: boolean = true;
  public disableCurrency: boolean = false;
  fadeInDown: any;
  private idConfig: number;
  public errorMessage: string;
  public pageTitle: string;
  public vconfigData: any = {
    type: 'Primary',
    stockslug: null,
    status: 'enabled',
    title: null,
    subTitle: null,
    tagline: null,
    label: null,
    icon: null,
    ticketbg: null,
    currencies: null,
    addlCurrencies: null,
    voucherslug: null,
    price: null,
    qtytemplate: null,
    btcEnabled: 0,
    ordering: 1,
    minorderval: 1,
  };
  public blurMatcher = new BlurInputErrorMatcher();
  public types: object[] = [{
    label: 'Currency',
    value: 'Primary'
  }, {
    label: 'Stock',
    value: 'Secondary'
  }];
  public status: object[] = [{
    label: 'Enabled',
    value: 'enabled'
  }, {
    label: 'Disabled',
    value: 'disabled'
  }];
  public btcEnabled: object[] = [{
    label: 'Yes',
    value: 1
  }, {
    label: 'No',
    value: 0
  }];

  constructor(public _api: ApirequestService,
              public _urls: ApiurlsService,
              public _utils: UtilityService,
              public router: Router,
              public toastr: ToastsManager, vcs: ViewContainerRef,
              private activatedRoute: ActivatedRoute,
              private orderPipe: OrderPipe,
              public _fb: FormBuilder) {
    this.toastr.setRootViewContainerRef(vcs);
  }

  getSecondaryAssets() {
    const data = {};
    this._api.fetchApiData(this._urls.stockListUrl, data).subscribe(
      (res: any) => {
        const response = res.data;
        const errRes = res.error;

        if (response) {
          this.secondaryAssets = response;

          this.getConfigDetails();
        } else {
          this.errorMessage = errRes['errorDescription'];
        }
      },
      error => {},
      () => {}
    );
  }

  getConfigDetails() {
    if (typeof this.idConfig !== 'undefined') {
      const data = { idVoucherConfig: this.idConfig };

      this._api.fetchApiData(this._urls.vconfigDetailsUrl, data).subscribe(
        (res: any) => {
          const response = res.data;
          const errRes = res.error;

          if (response) {
            this.vconfigData = response;

            if (this.vconfigData.type === 'Secondary') {
              let secCurrencies = this.vconfigData.currencies.replaceAll(' ', '');
              secCurrencies = secCurrencies.split(',');
              this.vconfigData.currencies = secCurrencies[0];
              secCurrencies = secCurrencies.splice(1, secCurrencies.length);
              this.vconfigData.addlCurrencies = secCurrencies.join(',');
            }
          } else {
            this.errorMessage = errRes['errorDescription'];
          }
        },
        error => {
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
    } else {
      this.showLoader = false;
    }
  }

  buildForm() {
    this.vconfigForm = this._fb.group({
      type: ['Primary', Validators.required],
      stockSlug: [null],
      status: ['enabled', Validators.required],
      title: [null, Validators.required],
      subTitle: [null],
      tagline: [null, Validators.required],
      label: [null, Validators.required],
      icon: [null, Validators.required],
      ticketBg: [null, Validators.required],
      currencies: [null, Validators.required],
      addlCurrencies: [null],
      voucherSlug: [null, Validators.required],
      price: [null, Validators.required],
      qtyTemplate: [null, Validators.required],
      btcEnabled: [0, Validators.required],
      minOrderVal: [1, Validators.required],
      ordering: [1, Validators.required]
    });

    this.vconfigForm.get('type').valueChanges.subscribe(value => {
      if (value === 'Secondary') {
        this.vconfigForm.get('stockSlug').setValidators(Validators.required);
        this.vconfigForm.controls.currencies.disable();
      } else {
        this.vconfigForm.get('stockSlug').clearValidators();
        this.vconfigForm.controls.currencies.enable();
      }
    });
  }

  onClick(action: string): void {
    if (action === 'submit') {
      this.showLoader = true;
      const formData = this.vconfigForm.value;

      if (formData.stockSlug === null) {
        delete formData.stockSlug;
      }
      if (typeof formData.currencies === 'undefined') {
        formData.currencies = this.vconfigData.currencies;
      }
      if (this.vconfigData.type === 'Secondary' && this.vconfigData.addlCurrencies !== null) {
        formData.currencies = formData.currencies + ', ' + this.vconfigData.addlCurrencies;
      }
      delete formData.addlCurrencies;

      if (typeof this.idConfig === 'undefined') {
        this._api.fetchApiData(this._urls.vconfigCreateUrl, formData).subscribe(
          (res: any) => {},
          error => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
            this.router.navigate(['/vconfig/list']);
          }
        );
      } else {
        formData.idVoucherConfig = this.idConfig;

        this._api.fetchApiData(this._urls.vconfigUpdateUrl, formData).subscribe(
          (res: any) => {},
          error => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
            this.router.navigate(['/vconfig/list']);
          }
        );
      }
    } else {
      this.router.navigate(['/vconfig/list']);
    }
  }

  updateSecondaryCurrency() {
    const prim = this.vconfigData.stockslug.split('-');
    this.vconfigData.currencies = prim[1];
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe( param => {
      this.idConfig = param.idVoucherConfig;
    });

    if (typeof this.idConfig === 'undefined') {
      this.pageTitle = 'Add new Voucher';
    } else {
      this.pageTitle = 'Edit Voucher';
    }

    this.getSecondaryAssets();
    this.buildForm();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/voucher-config/vconfig-add/vconfig-add.component.ts